/* eslint-disable consistent-return */
export default (user) => {
  let userID = user.userID;

  if(user.supervisorAgentID && user.supervisorAgentID > 0) {
    userID = user.supervisorAgentID;
  }

  return userID;
};



// WEBPACK FOOTER //
// ./src/features/agent-info-verification/util/isSupervisor.js